import { SideBarOptionMenu } from '@/types/sidebar'
import { MdOutlinePassword } from 'react-icons/md'

export const userUpdatePasswordMenu: SideBarOptionMenu = {
  name: 'Password',
  icon: MdOutlinePassword,
  path: '/update-password',
  order: 1,
  permission: null,
  isShown: true,
  isActive: false,
  child: [],
}
